import "./App.css";
import Dictionary from "./Dictionary";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header"></header>
        <main>
          <Dictionary defaultKeyword="Sunrise" />
        </main>
        <footer className="App-footer">
          <small>Coded by Ambika Kumari</small>
        </footer>
      </div>
    </div>
  );
}
